import gql from 'graphql-tag'

export default gql`mutation go($url: String!){
  downloadProjectClientInvoice(url: $url)
}`